<template>
  <q-select
    :placeholder="label"
    :disable="disable"
    :options="sectionsOptions"
    @filter="filterFunction"
    clearable
    fill-input
    filled
    hide-selected
    input-class="selected-city"
    input-debounce="0"
    :option-label="item => item.code + ' - ' + item.description"
    option-value="code"
    use-input
    v-model="value"
  >
    <template v-slot:prepend>
      <q-icon :name="label === 'Origem' ? 'trip_origin': 'room'" />
    </template>

    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          Sem resultados
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { mutations, store } from '../store'
import { setSessionStorage, removeAcento, getHost } from '../functions'

export default {
  props: {
    label: {
      type: String,
      default: 'Seccionamento',
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sections: {
      get () {
        return store.sections
      },

      set (value) {
        mutations.setSections(value)
      },
    },

    value: {
      get () {
        return this.$attrs.value
      },

      set (value) {
        this.$emit('update:value', value)
      },
    },

    isSmallWidth () {
      return window.innerWidth <= 320
    },
  },

  data () {
    return {
      sectionsOptions: [],
    }
  },

  mounted () {
    window.http.get(`${getHost()}/eucaturmobile/sections`).then(r => {
      this.sections = r.data
      this.sectionsOptions = r.data
      setSessionStorage('sections', r.data)
    })
  },

  methods: {
    filterFunction (val, update) {
      if (!val) {
        update(() => {
          this.sectionsOptions = this.sections
        })
        return
      }

      update(() => {
        const needle = removeAcento(val.trim().toLowerCase())
        this.sectionsOptions = this.sections.filter(s => removeAcento(s.description.trim().toLowerCase()).indexOf(needle) > -1)
      })
    },
  },
}
</script>

<style lang="scss">
.q-field__native > span {
  font-weight: 500;
}
</style>
